import script from "./SpeakersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeakersSection.vue?vue&type=script&setup=true&lang=js"

import "./SpeakersSection.vue?vue&type=style&index=0&id=2f4c10f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4c10f2"]])

export default __exports__